import { useAddSavedColorsToCollectionModalStore } from "../../../js/stores/add-saved-colors-to-collection-modal-store";
import { Dialog, DialogContent } from "../shared/modal";
import { AddSavedColorsToCollectionContent } from "./add-saved-colors-to-collection-content";

function AddSavedColorsToCollectionDialog({ isModalOpen, updateIsModalOpen }) {
  return (
    <Dialog
      open={isModalOpen}
      onClose={() => updateIsModalOpen(false)}
      onOpenChange={updateIsModalOpen}
    >
      <DialogContent className="react-modal-content--wide">
        <AddSavedColorsToCollectionContent />
      </DialogContent>
    </Dialog>
  );
}

export function AddSavedColorsToCollectionModal() {
  const isModalOpen = useAddSavedColorsToCollectionModalStore(
    (state) => state.isModalOpen
  );
  const updateIsModalOpen = useAddSavedColorsToCollectionModalStore(
    (state) => state.updateIsModalOpen
  );

  return (
    <>
      {isModalOpen && (
        <AddSavedColorsToCollectionDialog
          key={crypto?.randomUUID()}
          isModalOpen={isModalOpen}
          updateIsModalOpen={updateIsModalOpen}
        />
      )}
    </>
  );
}
